module.exports = __webpack_public_path__ + "img/live_ing.f31d3f9e.gif";